import {Component, Prop, Vue} from "vue-property-decorator";
import {VueEditor} from "vue2-editor";

const customToolbar = [
  ['bold', 'italic', 'underline'],
  ['blockquote', 'code-block', 'link', 'image'],
  [{ 'list': 'ordered' }, { 'list': 'bullet' }],
  [{ 'align': [] }],
  [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
  [{ 'color': [] }],
  ['clean']
]

@Component
export class RichTextEditor extends Vue {

  @Prop({type: [String, null]}) value: string;

  render() {
    return <VueEditor
      id="text-editor"
      class="text-editor"
      value={this.value}
      onInput={value => this.$emit("input", value)}
      editorToolbar={customToolbar}
      editorOptions={{
        modules: {}
      }}
    />;
  }

}
// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-644230b0/rich-text-editor.tsx" });